import React, { Component } from 'react'
import Select from 'react-select'

class WorkLocationType extends Component {
    constructor() {
        super()
        this.state = {
            WorkLocationTypeList:[ {"label":"OFFICE","value":"OFFICE"},{"label":"Kitchen","value":"Kitchen"}]
        }
        this.isComponentStillMounted = true
    }

   

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    

    render() {
       return (
            <div>
                <Select
                value={this.props.selectedValue}
                options={this.state.WorkLocationTypeList}
                placeholder="Select Work Location Type"
                onChange={(e) => { (e) ? this.props.workLocationTypeChange(e) : this.props.workLocationTypeChange([])}}
                />
            </div>
        )
    }
}

export default WorkLocationType


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/DropDowns/WorkLocationType.js